import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles/index";
import { Modal, Button, Alert } from "react-bootstrap";
import TextField from "@material-ui/core/TextField";
import CircularProgress from "@material-ui/core/CircularProgress";
import axios from "axios";
import { useFormik } from "formik";
import * as Yup from "yup";
import ReactSelect from "../../../../app/modules/UI/ReactSelect";
import ReactSelectNotClear from "../../../../app/modules/UI/ReactSelectNotClear";

const useStyles = makeStyles({
  list: {
    width: 400,
    height: "100vh",
  },
  card: {
    margin: "30px",
  },
  pointer: {
    cursor: "pointer",
  },
  progresRoot: {
    width: "100%",
    padding: "32px 16px",
  },
  progress: {
    margin: "auto",
    display: "block",
    color: "#072C8C",
  },
});
const initialValues = {
  name: "",
  surname: "",
  email: "",
  middleName: "",
  username: "",
  cardLimit: "",
  dutyId: "",
  structureId: "",
};

export default function Edit(props) {
  const classes = useStyles();
  const {
    onHide,
    show,
    onGroups,
    chooseGroupId,
    onGroupChoose,
    skip,
    take,
    sortField,
    orderBy,
    filterInputs,
    dutyId,
    structureId,
  } = props;

  const [isError, setIsError] = useState(false);
  const [isEditLoading, setIsEditLoading] = useState(false);
  const [chooseDutyOption, setChooseDutyOption] = useState([]);
  const [chooseStructureIdOption, setChooseStructureIdOption] = useState([]);

  const [department, setDepartment] = useState();
  const [directorate, setDirectorate] = useState();
  const [branch, setBranch] = useState();
  const [division, setDivision] = useState();
  const [structureType, setStructureType] = useState();

  const [chooseDepartmentOption, setChooseDepartmentOption] = useState([]);
  const [chooseDirectorateOption, setChooseDirectorateOption] = useState([]);
  const [chooseBranchOption, setChooseBranchOption] = useState([]);
  const [chooseDivisionOption, setChooseDivisionOption] = useState([]);
  const [chooseStructureTypeOption, setChooseStructureTypeOption] = useState(
    []
  );

  const onPutGroup = (values, resetForm, setSubmitting) => {
    setIsEditLoading(true);
    const group = {
      id: chooseGroupId,
      name: values.name ? values.name : "",
      surname: values.surname ? values.surname : "",
      email: values.email ? values.email : "",
      middleName: values.middleName ? values.middleName : "",
      username: values.username ? values.username : "",
      dutyId: values.dutyId ? values.dutyId : "",
      structureId: values.structureId ? values.structureId : "",
    };
    const group1 = {
      id: chooseGroupId,
      name: values.name,
      surname: values.surname,
      middleName: values.middleName,
      username: values.username,
      dutyId: values.dutyId,
      structureId: values.structureId,
    };
    axios
      .put(
        `${process.env.REACT_APP_API_URL}user/${chooseGroupId}`,
        values.email ? group : group1
      )
      .then(() => {
        onHide(false);
        resetForm();
        setSubmitting(false);
        onGroups(orderBy, sortField, skip, take, filterInputs);
        setIsEditLoading(false);
      })
      .catch((err) => {
        let message =
          typeof err.response !== "undefined"
            ? !err.response.data.checks && err.response.data.message
              ? err.response.data.message
              : (err.response.data.checks.name ||
                  err.response.data.checks.middleName ||
                  err.response.data.checks.surname) &&
                !err.response.data.checks.email
              ? "Ad , soyad və ata adı yalnız hərflərdən ibarət olmalıdır"
              : (err.response.data.checks.name ||
                  err.response.data.checks.middleName ||
                  err.response.data.checks.surname) &&
                err.response.data.checks.email
              ? "Ad , soyad və ata adı yalnız hərflərdən ibarət olmalıdır. Email formatı səhvdir. Örnək:jhon.doe@example.com "
              : !err.response.data.checks.name &&
                !err.response.data.checks.middleName &&
                !err.response.data.checks.surname &&
                err.response.data.checks.email &&
                "Email formatı səhvdir. Örnək: jhon.doe@example.com"
            : err.message;
        setIsError(message);
        setIsEditLoading(false);
      });
  };

  const EditSchema = Yup.object().shape({
    name: Yup.string()
      .min(3, "Ən az 3 hərf olmalıdır.")
      .max(255, "Ən çox 255 hərf ola bilər.")
      .required("Ad tələb olunur."),
    surname: Yup.string()
      .min(4, "Ən az 4 hərf olmalıdır.")
      .max(255, "Ən çox 255 hərf ola bilər.")
      .required("Soyad tələb olunur."),

    middleName: Yup.string().required("Ata adı tələb olunur."),
    username: Yup.string().required("İstifadəçi adı tələb olunur."),
    dutyId: Yup.string().required("Vəzifə tələb olunur."),
    structureId: Yup.string().required("Struktur ID tələb olunur."),
    //  cardLimit: Yup.string().required("Kart limit tələb olunur."),
  });

  const getInputClasses = (filedName) => {
    if (formik.touched[filedName] && formik.errors[filedName]) {
      return true;
    }
    if (formik.touched[filedName] && !formik.errors[filedName]) {
      return false;
    }

    return false;
  };

  const formik = useFormik({
    initialValues,
    validationSchema: EditSchema,
    onSubmit: (values, { resetForm, setSubmitting }) => {
      onPutGroup(values, resetForm, setSubmitting);
    },
  });

  const { setFieldValue } = formik;

  function handleChangeDuty(value) {
    setChooseDutyOption(value);
    setFieldValue("dutyId", value.value);
  }

  function handleChangeStructure(value) {
    setChooseStructureIdOption(value);
    setFieldValue("structureId", value ? value.value : "");

    axios
      .get(
        `${process.env.REACT_APP_API_URL}structure/select?id=${
          value ? value.value : ""
        }`
      )
      .then((res) => {
        const displayTypes = res.data.map(({ id, name, type }) => ({
          value: id,
          label: name,
          type: type,
        }));

        const newDepartmentItem = displayTypes.filter((obj) => {
          return obj.type === "DEPARTMENT";
        });

        const newDirectorateItem = displayTypes.filter((obj) => {
          return obj.type === "DIRECTORATE";
        });
        const newBranchItem = displayTypes.filter((obj) => {
          return obj.type === "BRANCH";
        });
        const newDivisionItem = displayTypes.filter((obj) => {
          return obj.type === "DIVISION";
        });
        const newStructureTypeItem = displayTypes.filter((obj) => {
          return obj.type === "STRUCTURE_TYPE";
        });
        setDepartment(newDepartmentItem);
        setDirectorate(newDirectorateItem);
        setBranch(newBranchItem);
        setDivision(newDivisionItem);
        setStructureType(newStructureTypeItem);

        setChooseDirectorateOption(null);
        setChooseBranchOption(null);
        setChooseDivisionOption(null);
        setChooseDepartmentOption(null);
        setChooseStructureTypeOption(null);
      });
  }
  const handleChangeDirectorateNames = (value) => {
    setChooseDirectorateOption(value);
    formik.setFieldValue("structureId", value ? value.value : "");

    axios
      .get(
        `${process.env.REACT_APP_API_URL}structure/select?id=${
          value ? value.value : ""
        }`
      )
      .then((res) => {
        const displayTypes = res.data.map(({ id, name, type }) => ({
          value: id,
          label: name,
          type: type,
        }));
        const newDepartmentItem = displayTypes.filter((obj) => {
          return obj.type === "DEPARTMENT";
        });
        const newBranchItem = displayTypes.filter((obj) => {
          return obj.type === "BRANCH";
        });
        const newDivisionItem = displayTypes.filter((obj) => {
          return obj.type === "DIVISION";
        });
        const newStructureTypeItem = displayTypes.filter((obj) => {
          return obj.type === "STRUCTURE_TYPE";
        });
        setDepartment(newDepartmentItem);
        setBranch(newBranchItem);
        setDivision(newDivisionItem);
        setStructureType(newStructureTypeItem);

        setChooseDepartmentOption(null);
        setChooseBranchOption(null);
        setChooseDivisionOption(null);
        setChooseStructureTypeOption(null);
      });
  };

  const handleChangeDepartmentNames = (value) => {
    setChooseDepartmentOption(value);
    formik.setFieldValue("structureId", value ? value.value : "");

    axios
      .get(
        `${process.env.REACT_APP_API_URL}structure/select?id=${
          value ? value.value : ""
        }`
      )
      .then((res) => {
        const displayTypes = res.data.map(({ id, name, type }) => ({
          value: id,
          label: name,
          type: type,
        }));

        const newBranchItem = displayTypes.filter((obj) => {
          return obj.type === "BRANCH";
        });
        const newDivisionItem = displayTypes.filter((obj) => {
          return obj.type === "DIVISION";
        });
        const newStructureTypeItem = displayTypes.filter((obj) => {
          return obj.type === "STRUCTURE_TYPE";
        });
        setBranch(newBranchItem);
        setDivision(newDivisionItem);
        setStructureType(newStructureTypeItem);

        setChooseBranchOption(null);
        setChooseDivisionOption(null);
        setChooseStructureTypeOption(null);
      });
  };

  const handleChangeBranchNames = (value) => {
    setChooseBranchOption(value);
    setFieldValue("structureId", value ? value.value : "");

    axios
      .get(
        `${process.env.REACT_APP_API_URL}structure/select?id=${
          value ? value.value : ""
        }`
      )
      .then((res) => {
        const displayTypes = res.data.map(({ id, name, type }) => ({
          value: id,
          label: name,
          type: type,
        }));

        const newDivisionItem = displayTypes.filter((obj) => {
          return obj.type === "DIVISION";
        });
        const newStructureTypeItem = displayTypes.filter((obj) => {
          return obj.type === "STRUCTURE_TYPE";
        });
        setDivision(newDivisionItem);
        setStructureType(newStructureTypeItem);

        setChooseDivisionOption(null);
        setChooseStructureTypeOption(null);
      });
  };

  const handleChangeDivisionNames = (value) => {
    setChooseDivisionOption(value);
    setFieldValue("structureId", value ? value.value : "");

    axios
      .get(
        `${process.env.REACT_APP_API_URL}structure/select?id=${
          value ? value.value : ""
        }`
      )
      .then((res) => {
        const displayTypes = res.data.map(({ id, name, type }) => ({
          value: id,
          label: name,
          type: type,
        }));

        const newStructureTypeItem = displayTypes.filter((obj) => {
          return obj.type === "STRUCTURE_TYPE";
        });
        setStructureType(newStructureTypeItem);
        setChooseStructureTypeOption(null);
      });
  };

  const handleChangeStructureTypeNames = (value) => {
    setChooseStructureTypeOption(value);
    setFieldValue("structureId", value ? value.value : "");
  };

  useEffect(() => {
    setIsEditLoading(true);
    onGroupChoose(chooseGroupId)
      .then((res) => {
        setFieldValue("name", res.data.name);
        setFieldValue("surname", res.data.surname);
        setFieldValue("email", res.data.email);
        setFieldValue("username", res.data.username);
        setFieldValue("middleName", res.data.middleName);
        setFieldValue("dutyId", res.data.dutyId);
        const displayTypes = res.data.structureList.map(
          ({ id, name, type }) => ({
            value: id,
            label: name,
            type: type,
          })
        );

        const newStructueItem = displayTypes.filter((obj) => {
          return obj.type === "COMPANY";
        });
        const newDepartmentItem = displayTypes.filter((obj) => {
          return obj.type === "DEPARTMENT";
        });

        const newDirectorateItem = displayTypes.filter((obj) => {
          return obj.type === "DIRECTORATE";
        });
        const newBranchItem = displayTypes.filter((obj) => {
          return obj.type === "BRANCH";
        });
        const newDivisionItem = displayTypes.filter((obj) => {
          return obj.type === "DIVISION";
        });
        const newStructureTypeItem = displayTypes.filter((obj) => {
          return obj.type === "STRUCTURE_TYPE";
        });

        setChooseDutyOption([
          {
            value: res.data.dutyId,
            label: res.data.dutyName,
          },
        ]);
        setChooseStructureIdOption(newStructueItem);
        setChooseDepartmentOption(newDepartmentItem);
        setChooseDirectorateOption(newDirectorateItem);
        setChooseBranchOption(newBranchItem);
        setChooseDivisionOption(newDivisionItem);
        setChooseStructureTypeOption(newStructureTypeItem);
        setFieldValue("structureId", res.data.structureId);

        setIsEditLoading(false);
        setIsError(false);
      })
      .catch((err) => {
        setIsEditLoading(false);
        setIsError(true);
      });
  }, [chooseGroupId, onGroupChoose, setFieldValue]);

  return (
    <Modal
      size="xl"
      aria-labelledby="edit"
      centered
      className="modal pr-0"
      show={show}
      onHide={onHide}
    >
      {isEditLoading ? (
        <div className={classes.progresRoot}>
          <CircularProgress className={classes.progress} />
        </div>
      ) : !isEditLoading ? (
        <form onSubmit={formik.handleSubmit}>
          <Modal.Header closeButton>
            <Modal.Title id="edit">Düzəliş et</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="col-12 pl-4 pr-4">
              <div className="row">
                <div className="col-6 col-md-6 col-lg-6">
                  <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                    <input
                      type="text"
                      name="structureId"
                      hidden
                      {...formik.getFieldProps("structureId")}
                    />

                    <ReactSelect
                      suggestions={structureId}
                      handleChangeSingle={(value) =>
                        handleChangeStructure(value)
                      }
                      single={chooseStructureIdOption}
                      label="Şirkət  seçin"
                      placeholder="Şirkət seçin"
                      inputId="structureId"
                    />
                  </div>
                  {formik.touched.structureId && formik.errors.structureId ? (
                    <div className="fv-plugins-message-container">
                      <div className="fv-help-block">
                        {formik.errors.structureId}
                      </div>
                    </div>
                  ) : null}
                </div>

                <div className="col-6 col-md-6 col-lg-6">
                  <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                    <input
                      type="text"
                      name="structureId"
                      hidden
                      {...formik.getFieldProps("structureId")}
                    />

                    <ReactSelect
                      suggestions={directorate}
                      handleChangeSingle={(value) =>
                        handleChangeDirectorateNames(value)
                      }
                      single={chooseDirectorateOption}
                      label="Direktorluq  seçin"
                      placeholder="Direktorluq seçin"
                      inputId="Directorate"
                    />
                  </div>
                  {formik.touched.structureId && formik.errors.structureId ? (
                    <div className="fv-plugins-message-container">
                      <div className="fv-help-block">
                        {formik.errors.structureId}
                      </div>
                    </div>
                  ) : null}
                </div>
                <div className="col-6 col-md-6 col-lg-6">
                  <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                    <input
                      type="text"
                      name="structureId"
                      hidden
                      {...formik.getFieldProps("structureId")}
                    />

                    <ReactSelect
                      suggestions={department}
                      handleChangeSingle={(value) =>
                        handleChangeDepartmentNames(value)
                      }
                      single={chooseDepartmentOption}
                      label="Departament  seçin"
                      placeholder="Departament seçin"
                      inputId="department"
                    />
                  </div>
                  {formik.touched.structureId && formik.errors.structureId ? (
                    <div className="fv-plugins-message-container">
                      <div className="fv-help-block">
                        {formik.errors.structureId}
                      </div>
                    </div>
                  ) : null}
                </div>
                <div className="col-6 col-md-6 col-lg-6">
                  <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                    <input
                      type="text"
                      name="structureId"
                      hidden
                      {...formik.getFieldProps("structureId")}
                    />

                    <ReactSelect
                      suggestions={branch}
                      handleChangeSingle={(value) =>
                        handleChangeBranchNames(value)
                      }
                      single={chooseBranchOption}
                      label="Şöbə  seçin"
                      placeholder="Şöbə seçin"
                      inputId="branch"
                    />
                  </div>
                  {formik.touched.structureId && formik.errors.structureId ? (
                    <div className="fv-plugins-message-container">
                      <div className="fv-help-block">
                        {formik.errors.structureId}
                      </div>
                    </div>
                  ) : null}
                </div>

                <div className="col-6 col-md-6 col-lg-6">
                  <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                    <input
                      type="text"
                      name="structureId"
                      hidden
                      {...formik.getFieldProps("structureId")}
                    />

                    <ReactSelect
                      suggestions={division}
                      handleChangeSingle={(value) =>
                        handleChangeDivisionNames(value)
                      }
                      single={chooseDivisionOption}
                      label="Bölmə seçin"
                      placeholder="Bölmə seçin"
                      inputId="division"
                    />
                  </div>
                  {formik.touched.structureId && formik.errors.structureId ? (
                    <div className="fv-plugins-message-container">
                      <div className="fv-help-block">
                        {formik.errors.structureId}
                      </div>
                    </div>
                  ) : null}
                </div>
                <div className="col-6 col-md-6 col-lg-6">
                  <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                    <input
                      type="text"
                      name="structureId"
                      hidden
                      {...formik.getFieldProps("structureId")}
                    />

                    <ReactSelect
                      suggestions={structureType}
                      handleChangeSingle={(value) =>
                        handleChangeStructureTypeNames(value)
                      }
                      single={chooseStructureTypeOption}
                      label="Struktur növü  seçin"
                      placeholder="Struktur növü seçin"
                      inputId="Struktur növü"
                    />
                  </div>
                  {formik.touched.structureId && formik.errors.structureId ? (
                    <div className="fv-plugins-message-container">
                      <div className="fv-help-block">
                        {formik.errors.structureId}
                      </div>
                    </div>
                  ) : null}
                </div>
                <div className="col-6 col-md-6 col-lg-6">
                  <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                    <input
                      type="text"
                      name="dutyId"
                      hidden
                      {...formik.getFieldProps("dutyId")}
                    />

                    <ReactSelectNotClear
                      suggestions={dutyId}
                      handleChangeSingle={(value) => handleChangeDuty(value)}
                      single={chooseDutyOption}
                      label="Vəzifə"
                      placeholder="Vəzifə"
                    />
                  </div>
                  {formik.touched.dutyId && formik.errors.dutyId ? (
                    <div className="fv-plugins-message-container">
                      <div className="fv-help-block">
                        {formik.errors.dutyId}
                      </div>
                    </div>
                  ) : null}
                </div>

                <div className="col-6 col-md-6 col-lg-6">
                  <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                    <TextField
                      id="name"
                      name="name"
                      label="Ad"
                      placeholder="Ad"
                      className="w-100"
                      error={getInputClasses("name")}
                      {...formik.getFieldProps("name")}
                    />
                  </div>
                  {formik.touched.name && formik.errors.name ? (
                    <div className="fv-plugins-message-container">
                      <div className="fv-help-block">{formik.errors.name}</div>
                    </div>
                  ) : null}
                </div>

                <div className="col-6 col-md-6 col-lg-6">
                  <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                    <TextField
                      id="surname"
                      name="surname"
                      label="Soyad"
                      placeholder="Soyad"
                      className="w-100"
                      error={getInputClasses("surname")}
                      {...formik.getFieldProps("surname")}
                    />
                  </div>
                  {formik.touched.surname && formik.errors.surname ? (
                    <div className="fv-plugins-message-container">
                      <div className="fv-help-block">
                        {formik.errors.surname}
                      </div>
                    </div>
                  ) : null}
                </div>
                <div className="col-6 col-md-6 col-lg-6">
                  <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                    <TextField
                      id="email"
                      name="email"
                      label="Email"
                      placeholder="Email"
                      className="w-100"
                      error={getInputClasses("email")}
                      {...formik.getFieldProps("email")}
                    />
                  </div>
                  {formik.touched.email && formik.errors.email ? (
                    <div className="fv-plugins-message-container">
                      <div className="fv-help-block">{formik.errors.email}</div>
                    </div>
                  ) : null}
                </div>
                <div className="col-6 col-md-6 col-lg-6">
                  <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                    <TextField
                      id="middleName"
                      name="middleName"
                      label="Ata adı"
                      placeholder="Ata adı"
                      className="w-100"
                      error={getInputClasses("middleName")}
                      {...formik.getFieldProps("middleName")}
                    />
                  </div>
                  {formik.touched.middleName && formik.errors.middleName ? (
                    <div className="fv-plugins-message-container">
                      <div className="fv-help-block">
                        {formik.errors.middleName}
                      </div>
                    </div>
                  ) : null}
                </div>
                <div className="col-6 col-md-6 col-lg-6">
                  <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                    <TextField
                      id="username"
                      name="username"
                      label="İstifadəçi adı"
                      placeholder="İstifadəçi adı"
                      className="w-100"
                      error={getInputClasses("username")}
                      {...formik.getFieldProps("username")}
                    />
                  </div>
                  {formik.touched.username && formik.errors.username ? (
                    <div className="fv-plugins-message-container">
                      <div className="fv-help-block">
                        {formik.errors.username}
                      </div>
                    </div>
                  ) : null}

                  {isError && (
                    <div className="fv-plugins-message-container">
                      <div className="fv-help-block MuiFormLabel-root Mui-error">
                        {isError}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="light"
              onClick={() => {
                onHide(false);
                formik.resetForm();
              }}
            >
              Ləğv et
            </Button>
            <Button type="submit" className={isEditLoading ? "px-9" : ""}>
              <span>Düzəliş et</span>
              {isEditLoading && (
                <span className="ml-3 spinner spinner-white"></span>
              )}
            </Button>
          </Modal.Footer>
        </form>
      ) : (
        <div className="p-5">
          <Alert variant="info">Xəta baş verdi.</Alert>
        </div>
      )}
    </Modal>
  );
}
